import React from 'react';
import { toSpecialFixed } from '@/lib/misc/utils';
import { getEthAmount } from '../SingleAssetHeader';
const QuotingConfirmationString = ({
  fromAssets,
  toAssets,
  amount,
  quoteStringInfo
}: {
  fromAssets: any;
  toAssets: any;
  amount: string | number;
  quoteStringInfo: any;
}) => {
  amount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (fromAssets?.length === 1 && toAssets?.length === 1) {
    return <div className='text-genius-cream/50 font-light'>
        <p>
          You are about to swap {toSpecialFixed(getEthAmount(fromAssets?.[0])).value}
          <span className='text-genius-cream ml-1'>{fromAssets?.[0]?.contract_ticker_symbol} </span>
          ({fromAssets?.[0]?.amountToUse?.toFixed(2)} USD) to
          <span className='text-genius-cream ml-1'>
            <span className='text-genius-cream/50'>
              {quoteStringInfo && quoteStringInfo[0] && toSpecialFixed(quoteStringInfo[0]?.formattedAmount, 3)?.value}
            </span>{' '}
            {toAssets?.[0]?.contract_ticker_symbol}
          </span>
        </p>
      </div>;
  }
  if (fromAssets?.length > 1 && toAssets?.length === 1) {
    return <div className='text-genius-cream/50'>
        You are about to swap{' '}
        {fromAssets.map((assetItem, index) => <div key={index}>
            <p>
              {toSpecialFixed(getEthAmount(assetItem))?.value} {assetItem.contract_ticker_symbol}
            </p>{' '}
            (<p>{assetItem.amountToUse?.toFixed(2)} USD</p>){' '}
            {index !== fromAssets.length - 1 && 'and '}
          </div>)}
        to <p>{toAssets?.[0]?.contract_ticker_symbol}</p>.
      </div>;
  }
  if (fromAssets?.length === 1 && toAssets?.length > 1) {
    return <div className='text-genius-cream/50'>
        You are about to swap{' '}
        <p>
          {getEthAmount(fromAssets[0])?.toFixed(4)} {fromAssets?.[0]?.contract_ticker_symbol}
        </p>{' '}
        (<p>{fromAssets[0].amountToUse?.toFixed(2)} USD</p>) for {toAssets?.length} tokens, split
        into a ratio of{' '}
        {toAssets.map((assetItem, index) => <div key={index}>
            <p>
              {toSpecialFixed(assetItem.percentage, 2)?.value}% {assetItem.contract_ticker_symbol}
            </p>{' '}
            (~<p>{(assetItem.percentage / 100 * amount)?.toFixed(2)} USD</p>){' '}
            {index !== toAssets.length - 1 && 'and '}
          </div>)}
      </div>;
  }
  if (fromAssets?.length > 1 && toAssets?.length > 1) {
    return <div className='text-genius-cream/50'>
        You are about to swap{' '}
        {fromAssets.map((assetItem, index) => <div key={index}>
            <p>
              {getEthAmount(assetItem)?.toFixed(4)} {assetItem.contract_ticker_symbol}
            </p>{' '}
            (<p>{assetItem.amountToUse?.toFixed(2)} USD</p>){' '}
            {index !== fromAssets.length - 1 && 'and '}
          </div>)}
        for {toAssets?.length} tokens, split into a ratio of{' '}
        {toAssets.map((assetItem, index) => <div key={index}>
            <p>
              {toSpecialFixed(assetItem.percentage, 2)?.value}% {assetItem.contract_ticker_symbol}
            </p>{' '}
            (~<p>{(assetItem.percentage / 100 * amount)?.toFixed(2)} USD</p>){' '}
            {index !== toAssets.length - 1 && 'and '}
          </div>)}
      </div>;
  }
  return null;
};
export default QuotingConfirmationString;